<template>
  <div class="content">
    <div class="title">充电台账</div>
    <el-divider></el-divider>
    <div class="tags">
      <div
          :class="action === item.value ? 'tag_item tag_item_active': 'tag_item'"
          v-for="(item, index) in tags"
          :key="index"
          @click="handleClick(item)"
      >{{ item.label }}
      </div>
    </div>
    <!--    <router-view />-->
    <ContentIncome v-show="action === 0"></ContentIncome>
    <ContentRecord v-show="action === 1"></ContentRecord>
  </div>
</template>

<script>
import ContentIncome from "./components/contentIncome"
import ContentRecord from "./components/contentRecord"
import {mapState, mapMutations} from 'vuex';

export default {
  name: "index",
  components: {
    ContentIncome,
    ContentRecord
  },
  data() {
    return {
      action: 0,
      tags: [
        {
          label: '收益查询',
          value: 0,
          path: ""
        }, {
          label: '充电记录',
          value: 1,
          path: "/Home/ContentRecord/index"
        }
      ]
    }
  },
  computed: {
    ...mapState(['pileIsSelect']) // 将 Vuex 的 state 映射到组件的计算属性中
  },
  methods: {
    ...mapMutations(['setPileIsSelect']),

    handleClick(item) {
      this.action = item.value
      this.setPileIsSelect(item.value)
    }
  }
}
</script>

<style scoped lang="less">

.el-divider {
  margin: 0;
}

.content {
  background-color: #fff;
  height: 100%;
  padding: 20rem 25rem 20rem 20rem;

  .title {
    font-size: 24rem;
    font-weight: bold;
    padding-bottom: 23rem;
  }

  .tags {
    display: flex;
    z-index: 33;

    .tag_item {
      font-size: 20rem;
      font-weight: bold;
      margin-right: 55rem;
      padding: 21rem 0 32rem 0;
      cursor: pointer;
      border-top: 4rem solid transparent;
    }

    .tag_item_active {
      color: #0D94FF;
      border-top: 4rem solid #0d94ff;
    }
  }

}
</style>